var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpediacom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#072f54}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4398",
    className: "cls-1",
    d: "m14 9.22-.47-1.37-4.08-5.48.73-.18 7.07 6.11 4.16-1.19A6.49 6.49 0 0 1 22.88 7 12 12 0 0 0 .7 8a11.75 11.75 0 0 0-.56 5.8l10-3.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4402",
    className: "cls-1",
    d: "M23.32 8a6.57 6.57 0 0 1-1.43.72L17.72 10l-2.78 8.93-.72.24.59-6.82-.33-1.42L10.57 12 .24 14.42A12 12 0 0 0 23.3 16a11.88 11.88 0 0 0 0-8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4406",
    d: "m14.47 10.87.33 1.42-.59 6.82.72-.24 2.78-8.93 4.17-1.19A6.15 6.15 0 0 0 23.31 8c-.13-.34-.31-.7-.43-1a5.92 5.92 0 0 0-1.47.15l-4.16 1.14-7.07-6.11-.73.18 4.1 5.48.45 1.37-3.93 1.13-10 3.45c0 .21.07.42.11.63L10.56 12l3.91-1.11z",
    style: {
      fill: "#fbc108"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpediacom);
export default __webpack_public_path__ + "static/media/Expediacom.d448a298d5bb9daf548c16026dc44676.svg";
export { ForwardRef as ReactComponent };